module.exports = __webpack_public_path__ + "static/img/275.b0422832.png";